module.exports = __webpack_public_path__ + "img/excel-icon.a233db3b.png";